import React, { useEffect, useState } from "react";
import { makeStyles } from "@mui/styles";
import {
  Button,
  Card,
  CardContent,
  Checkbox,
  FormControlLabel,
  FormHelperText,
  Grid,
  Input,
  TextField,
  IconButton,
} from "@mui/material";
import { Delete } from "@mui/icons-material";
import { callAPI } from "../../../App/Helpers/callApi";
import LoadingBar from "../../../App/Components/LoadingBar/LoadingBar";
import DropdownComponent from "../../../App/Components/Dropdown/DropdownComponent";
import { getBase64 } from "../../../App/Helpers/base64";
import DateTimePickerComponent from "../../../App/Components/Datepickers/DateTimePicker";
import { getEvents, saveEvent } from "../EventsService";
import { convertDateWithTime } from "../../../App/Helpers/DateConverters";
import DropdownSearch from "../../../App/Components/Dropdown/DropdownSearch";
import { zonedTimeToUtc } from "date-fns-tz";
import { findIana } from "windows-iana";
import AutoExpandableResizableTextarea from "../../../App/Components/AutoExpandableResizableTextarea";

const useStyles = makeStyles((theme) => ({
  root: {
    [theme.breakpoints.down("md")]: {
      width: "100%",
    },
    justifyContent: "space-between",
    width: "100%",
    display: "flex",
    flexDirection: "column",
  },
  error: {
    color: theme.palette.error.main,
  },
  image: {
    maxWidth: "200px",
    height: "auto",
    margin: "10px",
    display: "flex",
    justifyContent: "center",
  },
  imageContainer: {
    display: "flex",
  },
  copy: {
    color: theme.palette.primary.copy,
  },
}));
export default function AddEventModal({
  openModal,
  client,
  setShowSignifier,
  setResponseMessage,
  setShowError,
  setTableData,
  eventModel,
  includeinActive,
  setEventModel,
}) {
  var today = new Date();

  const classes = useStyles();

  const [processing, setProcessing] = useState(false);
  const [inputError, setInputError] = useState(false);

  const [selectedType, setSelectedType] = useState({});
  const [selectedTimezone, setSelectedTimezone] = useState(null);
  const [selectedVenue, setSelectedVenue] = useState({});
  const [selectedSponsors, setSelectedSponsors] = useState([]);

  const [title, setTitle] = useState("");
  const [typeName, setTypeName] = useState("");
  const [description, setDescription] = useState("");
  const [virtual, setVirtual] = useState(false);
  const [rsvp, setRsvsp] = useState(false);

  const [venueName, setVenueName] = useState("");
  const [venueWebsite, setVenueWebsite] = useState("");
  const [venueEmail, setVenueEmail] = useState("");
  const [venuePhone, setVenuePhone] = useState("");
  const [venueAddress, setVenueAddress] = useState("");
  const [venueCity, setVenueCity] = useState("");
  const [venueState, setVenueState] = useState("");
  const [venueZipcode, setVenueZipcode] = useState("");
  const [venueCountry, setVenueCountry] = useState("United States");

  const [registrationLink, setRegistrationLink] = useState("");
  const [startDate, setStartDate] = useState(today);
  const [endDate, setEndDate] = useState(
    new Date().setMinutes(today.getMinutes() + 1)
  );
  const [minEndDate, setMinEndDate] = useState(
    new Date().setMinutes(today.getMinutes() + 0.5)
  );

  const [encodedImage, setEncodedImage] = useState(null);
  const [fileName, setFileName] = useState("");
  const [contentType, setContentType] = useState("");
  const [image, setImage] = useState(null);
  const [imageError, setImageError] = useState(false);
  const [imageAltText, setImageAltText] = useState("");

  const uploadFile = (e) => {
    if (e.target.files[0] != null) {
      //Reset image
      setFileName("");
      setImage(null);
      setEncodedImage(null);

      var fileType = e.target.files[0].type;
      if (fileType !== "image/png" && fileType !== "image/jpeg") {
        setImageError(true);
        return;
      }
      var image = e.target.files[0];
      // Convert image size to MB
      var imageSizeInMb = image.size / (1024 * 1024);
      // Prevent images over 1MB from being uploaded
      if (imageSizeInMb > 1) {
        setImageError(true);
        return;
      }

      getBase64(image, (result) => {
        setImageError(false);
        setEncodedImage(result.split("base64,")[1]);
        var imageData =
          "data:" + image.contentType + ";base64," + result.split("base64,")[1];
        setImage(imageData);
        setFileName(e.target.files[0].name);
        setContentType(e.target.files[0].type);
      });
    }
  };

  function addEvent() {
    if (!checkAllEntered()) {
      setInputError(true);
      return;
    }

    var ianaTimezone = findIana(selectedTimezone).at(0);
    var updatedStartDate = zonedTimeToUtc(startDate, ianaTimezone);
    var updatedEndDate = zonedTimeToUtc(endDate, ianaTimezone);

    let eventData = {
      ClientId: client.id,
      EventTypeId: selectedType?.id,
      VenueId: selectedVenue?.id,
      IsVirtual: virtual,
      Title: title,
      Description: description,
      Image: encodedImage,
      ImageAlt: imageAltText,
      ContentType: contentType,
      RegistrationLink: registrationLink,
      StartDate: updatedStartDate,
      EndDate: updatedEndDate,
      HasRsvp: rsvp,
      IsActive: true,
      TimeZoneId: selectedTimezone,
    };

    let typeData = {
      ClientId: client.id,
      Name: typeName,
    };

    let venueData = {
      ClientId: client.id,
      Name: venueName,
      Address: venueAddress,
      City: venueCity,
      Division: venueState,
      ZipCode: venueZipcode,
      Country: venueCountry,
      Website: venueWebsite,
      PhoneNumber: venuePhone,
      EmailAddress: venueEmail,
    };

    let model = {
      eventData: eventData,
      typeData: selectedType.id !== undefined ? selectedType : typeData,
      venueData: selectedVenue.id !== undefined ? selectedVenue : venueData,
      SelectedSponsorIds: selectedSponsors,
    };

    callAPI(
      saveEvent(model),
      "Event Added",
      setShowSignifier,
      setResponseMessage,
      setShowError,
      setProcessing
    ).then(() => {
      getEvents(client.id, includeinActive).then((response) => {
        response.eventVenues = [{ name: "+ Add New" }].concat(
          response.eventVenues
        );
        response.eventTypes = [{ name: "+ Add New" }].concat(
          response.eventTypes
        );
        response.eventSponsors.forEach(
          (row) =>
            (row.imagePath = "data:" + row.contentType + ";base64," + row.logo)
        );
        response.events?.forEach((row) => {
          row.displayIsActive = row.isActive ? "Yes" : "No";
          row.startDate = convertDateWithTime(row.startDate);
          row.endDate = convertDateWithTime(row.endDate);
          row.sponsors = response.eventSponsors;
          row.types = response.eventTypes;
          row.venues = response.eventVenues;
          row.timeZones = response.timeZonesCollection;
        });
        setEventModel(response);
        setTableData(response.events);
        openModal(false);
      });
    });
  }

  const checkAllEntered = () => {
    if (
      title === "" ||
      description === "" ||
      selectedTimezone == null ||
      selectedTimezone === "" ||
      selectedType.name === undefined
    ) {
      return false;
    }
    if (!virtual) {
      if (selectedVenue.name === undefined) {
        return false;
      } else if (selectedVenue.name === "+ Add New") {
        if (
          venueName === "" ||
          venueAddress === "" ||
          venueCity === "" ||
          venueState === "" ||
          venueZipcode === "" ||
          venueCountry === ""
        ) {
          return false;
        }
      }
    }
    if (selectedType.name === "+ Add New") {
      if (typeName === "") {
        return false;
      }
    }
    if (endDate <= minEndDate) return false;
    // Validate image alt text if image is present
    if (encodedImage !== null && (imageAltText === "" || imageAltText.length > 255)) {
      return false;
    }
    else {
      return true;
    }
  };

  useEffect(() => {
    setMinEndDate(new Date(startDate).setMinutes(startDate.getMinutes() + 0.5));
  }, [startDate]);

  return (
    <div className={classes.root}>
      <LoadingBar loading={processing} />
      <Grid>
        <Card>
          <CardContent>
            <FormHelperText style={{ fontWeight: "bold" }}>
              Add Event
            </FormHelperText>
            <Grid container spacing={1}>
              <Grid item xs={12} sm={4}>
                <TextField
                  placeholder="Title"
                  label="Title"
                  variant="standard"
                  fullWidth
                  required
                  InputProps={{
                    className: classes.copy,
                  }}
                  value={title}
                  error={inputError && title === ""}
                  onChange={(e) => setTitle(e.target.value)}
                />
                {inputError && title === "" && (
                  <FormHelperText className={classes.error}>
                    Title Required
                  </FormHelperText>
                )}
              </Grid>
              <Grid item xs={12} sm={4}>
                <DropdownComponent
                  currValue={selectedType}
                  items={eventModel.eventTypes}
                  property="name"
                  title="Type"
                  handleChange={(value) => setSelectedType(value)}
                  error={inputError && selectedType.name === undefined}
                />
                {inputError && selectedType.name === undefined && (
                  <FormHelperText className={classes.error}>
                    Event Type Required
                  </FormHelperText>
                )}
              </Grid>
              <Grid item xs={12} sm={4}>
                {selectedType.name !== "+ Add New" ? null : (
                  <TextField
                    placeholder="New Type Name"
                    label="New Type Name"
                    variant="standard"
                    fullWidth
                    required
                    InputProps={{
                      className: classes.copy,
                    }}
                    value={typeName}
                    error={inputError && typeName === ""}
                    onChange={(e) => setTypeName(e.target.value)}
                  />
                )}
                {inputError &&
                  title === "" &&
                  selectedType.name === "+ Add New" && (
                    <FormHelperText className={classes.error}>
                      Type Name Required
                    </FormHelperText>
                  )}
              </Grid>
              <Grid item xs={12} sm={4}>
                <DateTimePickerComponent
                  value={startDate}
                  setValue={setStartDate}
                  error={inputError && startDate == null}
                  label="Start Date"
                />
              </Grid>
              <Grid item xs={12} sm={4}>
                <DateTimePickerComponent
                  value={endDate}
                  setValue={setEndDate}
                  minDate={startDate}
                  minTime={minEndDate}
                  error={endDate <= minEndDate}
                  label="End Date"
                />
                {endDate <= minEndDate && (
                  <FormHelperText className={classes.error}>
                    End Date must be after Start Date
                  </FormHelperText>
                )}
              </Grid>
              <Grid item xs={12} sm={4}>
                <DropdownSearch
                  items={eventModel.timeZonesCollection}
                  title="Time Zone *"
                  handleChange={(value) => setSelectedTimezone(value)}
                  currValue={selectedTimezone}
                  error={
                    inputError &&
                    (selectedTimezone == null || selectedTimezone === "")
                  }
                />
                {inputError &&
                  (selectedTimezone == null || selectedTimezone === "") && (
                    <FormHelperText className={classes.error}>
                      Timezone Required
                    </FormHelperText>
                  )}
              </Grid>
              <Grid item xs={12} sm={12}>
                <AutoExpandableResizableTextarea
                  label="Description"
                  placeholder="Description"
                  required={true}
                  value={description}
                  onChange={(e) => setDescription(e.target.value)}
                />
                {inputError && description === "" && (
                  <FormHelperText className={classes.error}>
                    Decription Required
                  </FormHelperText>
                )}
              </Grid>
              <Grid xs={12} sm={12} item>
                <FormControlLabel
                  className={classes.copy}
                  control={
                    <Checkbox
                      color="primary"
                      checked={virtual}
                      onChange={() => setVirtual(!virtual)}
                    />
                  }
                  label="Virtual"
                />
              </Grid>
              <Grid xs={12} sm={12} item>
                <FormControlLabel
                  className={classes.copy}
                  control={
                    <Checkbox
                      color="primary"
                      checked={rsvp}
                      onChange={() => setRsvsp(!rsvp)}
                    />
                  }
                  label="Accepts RSVP"
                />
              </Grid>
              {virtual ? null : (
                <Grid item xs={12} sm={12}>
                  <DropdownComponent
                    currValue={selectedVenue}
                    items={eventModel.eventVenues}
                    property="name"
                    title="Event Venue"
                    handleChange={(value) => setSelectedVenue(value)}
                    error={inputError && selectedVenue.name == null}
                  />
                  {inputError && selectedVenue.name == null && (
                    <FormHelperText className={classes.error}>
                      Event Venue Required
                    </FormHelperText>
                  )}
                </Grid>
              )}
              {selectedVenue.name !== "+ Add New" ? null : (
                <>
                  <Grid item xs={12} sm={6}>
                    <TextField
                      placeholder="Venue Name"
                      label="Venue Name"
                      variant="standard"
                      fullWidth
                      required
                      InputProps={{
                        className: classes.copy,
                      }}
                      value={venueName}
                      onChange={(e) => setVenueName(e.target.value)}
                      error={inputError && venueName === ""}
                    />
                    {inputError && venueName === "" && (
                      <FormHelperText className={classes.error}>
                        Venue name Required
                      </FormHelperText>
                    )}
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <TextField
                      placeholder="Venue Website"
                      label="Venue Website"
                      variant="standard"
                      fullWidth
                      required
                      InputProps={{
                        className: classes.copy,
                      }}
                      value={venueWebsite}
                      onChange={(e) => setVenueWebsite(e.target.value)}
                    />
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <TextField
                      placeholder="Venue Email"
                      label="Venue Email"
                      variant="standard"
                      fullWidth
                      required
                      InputProps={{
                        className: classes.copy,
                      }}
                      value={venueEmail}
                      onChange={(e) => setVenueEmail(e.target.value)}
                    />
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <TextField
                      placeholder="Venue Phone #"
                      label="Venue Phone #"
                      variant="standard"
                      fullWidth
                      required
                      InputProps={{
                        className: classes.copy,
                      }}
                      value={venuePhone}
                      onChange={(e) => setVenuePhone(e.target.value)}
                    />
                  </Grid>
                  <Grid item xs={12} sm={12}>
                    <TextField
                      placeholder="Venue Address"
                      label="Venue Address"
                      variant="standard"
                      fullWidth
                      required
                      InputProps={{
                        className: classes.copy,
                      }}
                      value={venueAddress}
                      onChange={(e) => setVenueAddress(e.target.value)}
                      error={inputError && venueAddress === ""}
                    />
                    {inputError && venueAddress === "" && (
                      <FormHelperText className={classes.error}>
                        Venue address Required
                      </FormHelperText>
                    )}
                  </Grid>
                  <Grid item xs={12} sm={3}>
                    <TextField
                      placeholder="Venue City"
                      label="Venue City"
                      variant="standard"
                      fullWidth
                      required
                      InputProps={{
                        className: classes.copy,
                      }}
                      value={venueCity}
                      onChange={(e) => setVenueCity(e.target.value)}
                      error={inputError && venueCity === ""}
                    />
                    {inputError && venueCity === "" && (
                      <FormHelperText className={classes.error}>
                        Venue city Required
                      </FormHelperText>
                    )}
                  </Grid>
                  <Grid item xs={12} sm={3}>
                    <TextField
                      placeholder="Venue State"
                      label="Venue State"
                      variant="standard"
                      fullWidth
                      required
                      InputProps={{
                        className: classes.copy,
                      }}
                      value={venueState}
                      onChange={(e) => setVenueState(e.target.value)}
                      error={inputError && venueState === ""}
                    />
                    {inputError && venueState === "" && (
                      <FormHelperText className={classes.error}>
                        Venue state Required
                      </FormHelperText>
                    )}
                  </Grid>
                  <Grid item xs={12} sm={3}>
                    <TextField
                      placeholder="Venue Zip Code"
                      label="Venue Zip Code"
                      variant="standard"
                      fullWidth
                      required
                      InputProps={{
                        className: classes.copy,
                      }}
                      value={venueZipcode}
                      onChange={(e) => setVenueZipcode(e.target.value)}
                      error={inputError && venueZipcode === ""}
                    />
                    {inputError && venueZipcode === "" && (
                      <FormHelperText className={classes.error}>
                        Venue zipcode Required
                      </FormHelperText>
                    )}
                  </Grid>
                  <Grid item xs={12} sm={3}>
                    <TextField
                      placeholder="Venue Country"
                      label="Venue Country"
                      variant="standard"
                      fullWidth
                      required
                      InputProps={{
                        className: classes.copy,
                      }}
                      value={venueCountry}
                      onChange={(e) => setVenueCountry(e.target.value)}
                      error={inputError && venueCountry === ""}
                    />
                    {inputError && venueCountry === "" && (
                      <FormHelperText className={classes.error}>
                        Venue country Required
                      </FormHelperText>
                    )}
                  </Grid>
                </>
              )}
              <Grid item xs={12} sm={12}>
                <TextField
                  placeholder="Registration Link"
                  label="Registration Link"
                  variant="standard"
                  fullWidth
                  InputProps={{
                    className: classes.copy,
                  }}
                  value={registrationLink}
                  onChange={(e) => setRegistrationLink(e.target.value)}
                />
              </Grid>
              <Grid item style={{ marginTop: "2%" }} xs={12} sm={12}>
                Event Image:
              </Grid>
              {image !== null ? (
                <>
                  <div className={classes.imageContainer}>
                    <img className={classes.image} src={image} alt="Event Logo" />
                    <div style={{ alignSelf: "center" }}>
                      <IconButton
                        onClick={() => {
                          setFileName("");
                          setImage(null);
                          setEncodedImage(null);
                          setImageAltText("");
                        }}
                        size="large"
                      >
                        <Delete />
                      </IconButton>
                    </div>
                  </div>
                  <Grid item xs={12} sm={12}>
                    <TextField
                      placeholder="Image Alt Text"
                      label="Image Alt Text"
                      variant="standard"
                      fullWidth
                      required
                      InputProps={{
                        className: classes.copy,
                      }}
                      value={imageAltText}
                      onChange={(e) => setImageAltText(e.target.value)}
                      error={inputError && (imageAltText === "" || imageAltText.length > 255)}
                      inputProps={{ maxLength: 255 }}
                    />
                    {inputError && imageAltText === "" && (
                      <FormHelperText className={classes.error}>
                        Alt text is required when an image is uploaded
                      </FormHelperText>
                    )}
                    {inputError && imageAltText.length > 255 && (
                      <FormHelperText className={classes.error}>
                        Alt text must be 255 characters or less
                      </FormHelperText>
                    )}
                    <FormHelperText>
                      {imageAltText.length}/255 characters
                    </FormHelperText>
                  </Grid>
                </>
              ) : (
                <Grid item xs={12} sm={6}>
                  <label htmlFor="contained-button-file">
                    <Input
                      accept="image/*"
                      id="contained-button-file"
                      multiple
                      type="file"
                      style={{ display: "none" }}
                      onInput={(e) => uploadFile(e)}
                    />
                    <Button
                      variant="contained"
                      color="primary"
                      component="span"
                      style={{ marginBottom: "10px" }}
                    >
                      Upload
                    </Button>
                    {imageError && image == null && (
                      <FormHelperText className={classes.error}>
                        Images must be a .PNG or .JPG file under 1MB in size.
                      </FormHelperText>
                    )}
                  </label>
                </Grid>
              )}
              <Grid
                container
                justifyContent="flex-end"
                direction="row"
                style={{ marginRight: "10px" }}
              >
                <Grid item xs={6} sm={3}>
                  <Button
                    style={{ color: "#82B288", marginTop: "20px" }}
                    type="submit"
                    variant="outlined"
                    fullWidth
                    onClick={() => openModal(false)}
                  >
                    Cancel
                  </Button>
                </Grid>
                <Grid item xs={6} sm={3}>
                  <Button
                    style={{ marginTop: "20px", marginLeft: "10px" }}
                    type="submit"
                    variant="contained"
                    color="primary"
                    fullWidth
                    onClick={() => addEvent()}
                  >
                    Save
                  </Button>
                </Grid>
              </Grid>
            </Grid>
          </CardContent>
        </Card>
      </Grid>
    </div>
  );
}
